import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=2f4e5410"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports